import html2pdf from 'html2pdf.js';
import { useState, useEffect, useRef } from "react";
import Bredcrum from "../../components/bredcrum";
import { Tag } from "primereact/tag";
import { Tablescom } from "../../components/tablescomp";
import { Toast } from "primereact/toast";

import { userservices } from "../../services/userServices";
import { productservices } from "../../services/productServices";
import { supplierservices } from "../../services/supplierServices";
import { purchaseorderservices } from "../../services/purchaseorderService";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";
import { useNavigate,useLocation } from "react-router";
import { useSelector } from 'react-redux';
import { useFormikContext,useFormik,Field,Formik,Form,FieldArray } from 'formik';
import '../../assets/recipttemplate.css';

const Showpurchaseorder = () => {
  const toast = useRef(null);
  const pdfRef = useRef();
  const location = useLocation();
  const unitreducer = useSelector((state)=>state.unitreducer);
  const currencyreducer = useSelector((state)=>state.currencyreducer);
  const [units,setUnits] = useState([]);
  const [currencies,setCurrencies] = useState([]);
  const [components,setComponents] = useState({});
  const [rows,setRows] = useState([]); 
  const [supllierlist,setSupllierlist] = useState([]);
  const [results,setResults] = useState([]);
  const [totalcost,setTotalcost] = useState({'totalcost':0,'subtotal':0});
  const [userloaded,setUserLoaded] = useState(true);
  const [shippingaddress,setShippingaddress] = useState({});
  const [shippingcurrency,setShippingcurrency] = useState('');

  const [formData, setFormData] = useState({
    component: "",
    componentSkuCode: "",
    componentType: "",
    description: "",
    supplier: "",
    cost: "",
    stockLevel: "",
    freightCharges: "",
    unitOfMeasurement: "",
    superdrugSkuCode: "",
    notes: "",
    supplier_cost:""
  });

  useEffect(()=>{
    console.log("location");
    console.log(location.state);

    getcurrency();
    setComponents({
      'podate':new Date().toISOString().slice(0, 10)
    });

    getpurchaseOrder(location.state.ponumber);
  },[]);

   const getcurrency = () => {
    currencyreducer.then((response)=>{
        setCurrencies(response);
      }).catch((error)=>{
    });
   } 

   const handleDownload = () => {
      console.log("doanloa dfile");
      const element = pdfRef.current;
      html2pdf().from(element).save('document.pdf');
    };

  function getpurchaseOrder(ponumber){
        // setUserLoaded(true);
    purchaseorderservices.getpurchaseOrder(ponumber).then((response)=>{
            if(response.status == 200){
                setResults(response.data.data);
                setTotalcost({totalcost:response.data.total_cost,subtotal:response.data.subtotal_cost});  
                setUserLoaded(false);
                setShippingaddress(response.data.shipping_address);
                setShippingcurrency(response.data.freight_currency);
               
            }else{
                setResults([]);
                setTotalcost({});
                setUserLoaded(false);
                setShippingaddress('');
                setShippingcurrency('');
            } 
    }).catch((error)=>{
            setResults([]);
            setTotalcost('');
            setUserLoaded(false);
            setShippingaddress('');
            setShippingcurrency('');
    });
 }  

 const displayData = () =>{
    let temp = [];
    results.forEach((value,index) => {
        temp.push( <tr>
            <td style={{ border: '1px solid #926b6b', padding: '8px' }}>{value?.ponumber}</td>
            <td style={{ border: '1px solid #926b6b', padding: '8px' }}>{value?.component}</td>
            <td style={{ border: '1px solid #926b6b', padding: '8px' }}>{value?.quantity} ({value?.unit})</td>
            <td style={{ border: '1px solid #926b6b', padding: '8px' }}>{value?.currency_symbol} {value?.unitprice}</td>
            <td style={{ border: '1px solid #926b6b', padding: '8px' }}>{value?.currency_symbol} {value?.totalcost}</td>
        </tr> );  
    });
    return temp;
}

const ShippingaddressComp = () =>{
    return(
        <>
           {shippingaddress?.street_address}<br/>
           {shippingaddress?.city}<br/>
           {shippingaddress?.state}<br/>
           {shippingaddress?.postal_code}<br/>
        </>  
    );   
}


  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Product/addproduct"} divider={false} />
      <div class="row">
        <div className='flex-box flex-between'>
              <div>
                 <Titlebar text={"Receipt"} />
              </div>
             
              <button className='btn btn-primary btn-xs rounded' onClick={() => handleDownload()}><i className='fa fa-download'></i>&nbsp;Downlaod</button>       
        </div> 
               
        <div className="col-md-12 mt-3">
          <div className="card ps-5 pe-5">
            <div className="card-body card-body-style">
              <div className="row">
                <div className="container mt-4"></div>
                     
                                              
                      <div class="po-container" ref={pdfRef}>
                           <div className="header" style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '3px solid #926b6b', paddingBottom: '10px' }}>
                                <div className="logo">
                                <img src="https://utan.co.uk/cdn/shop/files/utan_logo_153x275_1_65x116.png?v=1700242623" alt="GimBooks Logo" style={{ height: '50px' }} />
                                <br />
                                {/* <h2 style={{ color: '#0073e6', margin: 0 }}>Utan</h2> */}
                                <div>
                                    [Street Address]<br />
                                    [City, ST ZIP]<br />
                                    Phone: (000) 000-0000<br />
                                    Fax: (000) 000-0000<br />
                                    Website:
                                </div>
                                </div>
                                <div className="purchase-order" style={{ color: '#926b6b', fontSize: '24px', fontWeight: 'bold', textAlign: 'right' }}>
                                <span  style={{display:'block',paddingBottom:'10px'}}>PURCHASE ORDER</span>
                                <small style={{ fontSize: '14px' }}><p className='m-0'>Date: {results[0]?.podate}</p>
                                <p className='m-0'>PO #: {results[0]?.ponumber}</p>
                                </small>
                                </div>
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                                <div className="section" style={{ width: '48%' }}>
                                <div className="title" style={{ backgroundColor: '#926b6b', color: 'white', padding: '5px', fontWeight: 'bold' }}>VENDOR</div>
                                <div className="content" style={{ padding: '2px' }}>
                                    {results[0]?.shopname}<br />
                                    {results[0]?.name}<br />
                                    {results[0]?.address}<br />
                                    [City, ST ZIP]<br />
                                    Phone: {results[0]?.phone}<br />
                                    Fax: (000) 000-0000
                                </div>
                                </div>

                                <div className="section" style={{ width: '48%' }}>
                                <div className="title" style={{ backgroundColor: '#926b6b', color: 'white', padding: '5px', fontWeight: 'bold' }}>SHIP TO</div>
                                <div className="content" style={{  padding: '2px' }}>
                                    {ShippingaddressComp()}
                                    Phone:
                                </div>
                                </div>
                            </div>

                            <table style={{ width: '100%', marginTop: '20px' }}>
                                <tbody>
                                <tr>
                                    <td><strong>REQUISITIONER</strong>: </td>
                                    <td><strong>SHIP VIA</strong>: </td>
                                    <td><strong>F.O.B.</strong>: </td>
                                    <td><strong>SHIPPING TERMS</strong>: </td>
                                </tr>
                                </tbody>
                            </table>

                            <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
                                <thead>
                                <tr style={{ backgroundColor: '#926b6b', color: 'white' }}>
                                    <th style={{ border: '1px solid #926b6b', padding: '8px' }}>ITEM #</th>
                                    <th style={{ border: '1px solid #926b6b', padding: '8px' }}>DESCRIPTION</th>
                                    <th style={{ border: '1px solid #926b6b', padding: '8px' }}>QTY</th>
                                    <th style={{ border: '1px solid #926b6b', padding: '8px' }}>UNIT PRICE</th>
                                    <th style={{ border: '1px solid #926b6b', padding: '8px' }}>TOTAL</th>
                                </tr>
                                </thead>
                                <tbody>
                                 {displayData()}
                                </tbody>
                            </table>

                            <div className="section" style={{ marginTop: '20px' }}>
                                <div className="title" style={{ backgroundColor: '#926b6b', color: 'white', padding: '5px', fontWeight: 'bold' }}>
                                Comments or Special Instructions
                                </div>
                                <div className="content" style={{ border: '1px solid #926b6b', padding: '10px' }}>
                                Please call 48 hours in advance to book delivery.
                                </div>
                            </div>

                            <table style={{ width: '300px', float: 'right', marginTop: '20px' }}>
                                <tbody>
                                <tr>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>SUBTOTAL:</td>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>{results[0]?.currency_symbol} {totalcost.subtotal}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>TAX:</td>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>-</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>SHIPPING:</td>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>{shippingcurrency} {location.state.freight_cost}</td>
                                </tr>
                                <tr>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>OTHER:</td>
                                    <td style={{ textAlign: 'right', padding: '5px' }}>-</td>
                                </tr>
                                <tr style={{ backgroundColor: '#926b6b', fontWeight: 'bold' }}>
                                    <td style={{ textAlign: 'right', padding: '5px',color:'white' }}>TOTAL:</td>
                                    <td style={{ textAlign: 'right', padding: '5px',color:'white' }}>{results[0]?.currency_symbol} {totalcost.totalcost}</td>
                                </tr>
                                </tbody>
                            </table>

                            <div style={{clear:'both'}}></div>

                            <div className="footer-new" style={{  fontSize: '12px', borderTop: '1px solid #926b6b', paddingTop: '10px' }}>
                                If you have any questions about this purchase order, please contact<br />
                                [Name, Phone #, E-mail]
                            </div>

                        {/* <div class="header">
                        <h1>Purchase Order</h1>
                        <div class="po-info">
                            <p><strong>PO Number:</strong> PO-00123</p>
                            <p><strong>Date:</strong> 24 June 2025</p>
                        </div>
                        </div>

                        <div class="section">
                        <h3>Supplier Details</h3>
                        <p><strong>Name:</strong> ABC Components Ltd.</p>
                        <p><strong>Contact:</strong> John Doe</p>
                        <p><strong>Email:</strong> supplier@example.com</p>
                        <p><strong>Phone:</strong> +91-9876543210</p>
                        </div>

                        <div class="section">
                        <h3>Delivery Details</h3>
                        <p><strong>Deliver To:</strong> Tricogen Warehouse</p>
                        <p><strong>Address:</strong> 123 Industrial Lane, Bengaluru, IN</p>
                        <p><strong>Expected Delivery:</strong> 01 July 2025</p>
                        </div>

                        <div class="section">
                        <h3>Order Summary</h3>
                        <table>
                            <thead>
                            <tr>
                                <th>Item</th>
                                <th>SKU</th>
                                <th>Qty</th>
                                <th>Unit</th>
                                <th>Unit Price</th>
                                <th>Total</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Utan 100ml Spray Bottle</td>
                                <td>CUTAN024</td>
                                <td>5,000</td>
                                <td>Pcs</td>
                                <td>₹12.50</td>
                                <td>₹62,500.00</td>
                            </tr>
                            <tr>
                                <td>Gold Overcap</td>
                                <td>GOC100</td>
                                <td>5,000</td>
                                <td>Pcs</td>
                                <td>₹3.00</td>
                                <td>₹15,000.00</td>
                            </tr>
                            </tbody>
                        </table>
                        </div>

                        <table class="totals">
                        <tr>
                            <td>Subtotal:</td>
                            <td>₹77,500.00</td>
                        </tr>
                        <tr>
                            <td>Tax (18%):</td>
                            <td>₹13,950.00</td>
                        </tr>
                        <tr>
                            <td>Total:</td>
                            <td>₹91,450.00</td>
                        </tr>
                        </table>

                        <div style={{'clear':'both'}}></div>

                        <div class="footer-new">
                        <p>This document is system-generated. Please quote the PO number on all shipments and invoices.</p>
                        <p>For queries, contact: <strong>orders@example.com</strong></p>
                        </div> */}
                    </div>  
                  
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Showpurchaseorder;
